import React, { useState } from 'react';
import { authApi, fetchCsrfCookie } from '../services/api';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      // C01 — Sanctum SPA : refresh du cookie XSRF-TOKEN avant tout POST mutant
      // pour le cas où l'utilisateur arrive directement sur /forgot-password
      // sans être passé par /login.
      await fetchCsrfCookie();
      await authApi.forgotPassword({ email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erreur lors de l\'envoi du lien de réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Mot de passe oublié</h1>
        
        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}

        {success && (
          <div className="auth-success">
            Un lien de réinitialisation a été envoyé à votre adresse email.
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="votre@email.com"
              disabled={loading || success}
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading || success}>
            {loading ? 'Envoi...' : 'Envoyer le lien'}
          </button>
        </form>

        <div className="auth-links">
          <a href="/login">Retour à la connexion</a>
        </div>
      </div>
    </div>
  );
};
